var React = require('react');

function NavIconsDataExplorer (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m12 1.61a10.39 10.39 0 1 0 10.39 10.39 10.39 10.39 0 0 0 -10.39-10.39zm0 19.67a9.28 9.28 0 1 1 9.28-9.28 9.29 9.29 0 0 1 -9.28 9.28zm2-17.17-3.32 6.1a2.25 2.25 0 0 0 -.74 2.79l.06 6.9 3.33-6.09a2.25 2.25 0 0 0 .72-2.81zm-2 8.8a.91.91 0 1 1 .91-.9.9.9 0 0 1 -.91.9z"}));
}

NavIconsDataExplorer.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavIconsDataExplorer;

NavIconsDataExplorer.default = NavIconsDataExplorer;
